import React from "react";
import LuxuryCursor from "./components/LuxuryCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Solutions from "./components/Solutions";
import TestimonialsStats from "./components/TestimonialsStats";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="bg-brand-dark text-white min-h-screen">
      {/* Luxury custom gold dot cursor */}
      <LuxuryCursor />
      {/* Sticky navigation bar with clickable logo/slogan */}
      <Navbar />

      <main>
        {/* Hero: smoke reveal, personalized greeting, city detection, slogan, luxury quote */}
        <Hero />

        {/* Slogan divider bar */}
        <div className="text-center py-8">
          <span className="inline-block px-6 py-1 text-gold border border-gold rounded-full font-serif tracking-widest bg-gold/10 shadow backdrop-blur-sm">
            Intelligence in Every Inch
          </span>
        </div>

        {/* Animated module cards with gold light reflection */}
        <Solutions />

        {/* Auto-animated testimonials & live stats */}
        <TestimonialsStats />

        {/* Company about section, contact form, footer */}
        <About />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
